import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import { ItemDescription, ItemTitle } from 'components/Product/Atoms/Feature';
import Image from 'next/image';
import styled, { css } from 'styled-components';
import { ItemCommonComponentContainer } from './ItemVideoComponent';

interface Props {
  imageSrcArray: string[];
  featureTitle: string;
  featureDescription?: string[];
  artDirection: boolean;
  wrapMedia: boolean;
}
export const ItemImageComponent = ({
  imageSrcArray,
  featureTitle,
  featureDescription,
  artDirection,
  wrapMedia,
}: Props) => {
  return (
    <ItemImageComponentContainer
      wrapMedia={wrapMedia}
      imgsLength={imageSrcArray.length}
    >
      <ItemTitle>{featureTitle}</ItemTitle>

      {artDirection ? (
        // art direction
        <div className="imgs-wrapper art-d">
          {imageSrcArray.map((imgSrc, i: number) => (
            <div
              className={i === 0 ? 'i-inner desk' : 'i-inner mob'}
              key={imgSrc}
            >
              <div className="i">
                <ImgBackgroundWrapper isNormalUse>
                  <Image
                    src={imgSrc}
                    layout="fill"
                    alt=""
                    className="target-img"
                    objectFit="cover"
                    quality={70}
                    sizes="(min-width: 906px) 95vw,
                         (min-width: 600px) 80vw,
                         (max-width: 599px) 75vw"
                  />
                </ImgBackgroundWrapper>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // art direction 아닌 경우
        <div className="imgs-wrapper">
          {imageSrcArray.map(imgSrc => (
            <div className="i-inner" key={imgSrc}>
              <div className="i">
                <ImgBackgroundWrapper isNormalUse>
                  <Image
                    src={imgSrc}
                    layout="fill"
                    alt=""
                    className="target-img"
                    objectFit="fill"
                    quality={70}
                    sizes="(min-width: 906px) 95vw,
                  (min-width: 600px) 80vw,
                  (max-width: 599px) 75vw"
                  />
                </ImgBackgroundWrapper>
              </div>
            </div>
          ))}
        </div>
      )}

      {featureDescription.length !== 0 && (
        <>
          {featureDescription.map(fd => (
            <ItemDescription className="item-desc" key={fd}>
              {fd}
            </ItemDescription>
          ))}
        </>
      )}
    </ItemImageComponentContainer>
  );
};

const ItemImageComponentContainer = styled(ItemCommonComponentContainer)<{
  wrapMedia: boolean;
  imgsLength: number;
}>`
  .imgs-wrapper {
    display: flex;
  }
  .i-inner {
    width: 100%;
    position: relative;
  }
  .i {
    width: 100%;
  }
  .i-inner + .i-inner {
    margin-left: 8px;
  }
  .imgs-wrapper:not(.art-d) .i-inner {
    padding-top: ${({ imgsLength }) =>
      imgsLength === 0 ? '56.25%' : `calc(56.25% / ${imgsLength})`};
  }
  .imgs-wrapper.art-d .i-inner {
    height: 328px;
  }
  .item-desc {
    margin-top: 8px;
  }
  .item-desc + .item-desc {
    margin-top: 0px;
  }
  .desk {
    display: block;
  }
  .mob {
    display: none;
  }
  @media screen and (max-width: 904px) {
    .desk {
      display: none;
    }
    .mob {
      display: block;
    }
    ${({ wrapMedia }) =>
      wrapMedia &&
      css`
        .imgs-wrapper:not(.art-d) .i-inner {
          padding-top: 56.25%;
        }
        .imgs-wrapper {
          flex-direction: column;
        }
        .i-inner + .i-inner {
          margin-left: 0;
          margin-top: 8px;
        }
      `};
  }
`;
